module.exports = __webpack_public_path__ + "static/media/logo.140d6060.png";